/**
 * Benannte Luecke fuer fehlende Werte in PDF-Ausgaben.
 *
 * Hausregel: Ein fehlender Wert wird benannt, nie als Gedankenstrich
 * gedruckt — ein „—" liest sich als geprueft-und-ohne-Befund. Bei der Zahl
 * der Beschaeftigten auf der Vorankuendigung hiesse ein „-" „keine", bei
 * einer Plan-Nr. „es gibt keine", in einer Befundspalte „nichts gefunden".
 * Alles drei sind andere Sachverhalte als „nicht ausgefuellt".
 *
 * Die Formulierung stand schon im Aushang (`generatorAushang.ts`) und im
 * Organigramm des Handbuchs; hier liegt sie einmal fuer die Generatoren.
 */
export const NICHT_ANGEGEBEN = 'nicht angegeben';

/**
 * Kurzform fuer schmale Tabellenspalten (unter rund 22 mm bei 8 pt), in
 * denen die Langform auf zwei Zeilen umbraeche und jede Luecke die Zeile
 * verdoppelte.
 */
export const FEHLT = 'fehlt';
